/* istanbul ignore file */
import { createRouteRef, createSubRouteRef } from "@backstage/core-plugin-api";

export const rootRouteRef = createRouteRef({
  id: "ria",
});

export const uploadRouteRef = createSubRouteRef({
  id: "ria/upload",
  parent: rootRouteRef,
  path: "/upload",
});

export const dashboardRouteRef = createSubRouteRef({
  id: "ria/dashboard",
  parent: rootRouteRef,
  path: "/dashboard",
});

export const portalRouteRef = createSubRouteRef({
  id: "ria/agents",
  parent: rootRouteRef,
  path: "/agents",
});

export const taskListRouteRef = createSubRouteRef({
  id: "ria/tasks",
  parent: rootRouteRef,
  path: "/tasks",
});

export const logsRouteRef = createSubRouteRef({
  id: "ria/logs",
  parent: rootRouteRef,
  path: "/logs",
});

export const policyRulesRouteRef = createSubRouteRef({
  id: "ria/policy-rules",
  parent: rootRouteRef,
  path: "/policy-rules",
});
